import callRequestBase from '../../call-request-base/call-request-base';
import callRequestBabyloanForm from './call-request-babyloan-form/call-request-babyloan-form.vue';
export default {
	extends: callRequestBase,
	components: {
		callRequestBabyloanForm
	}
};
